import type { SVGProps } from 'react';
const SvgDriveFileRenameOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#drive_file_rename_outline_svg__a)">
      <path
        fill="currentColor"
        d="M18.41 5.8 17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83ZM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18ZM11 20l4-4h6v4H11Z"
      />
    </g>
    <defs>
      <clipPath id="drive_file_rename_outline_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDriveFileRenameOutline;
